export const ALPHA2_TO_METADATA = {
  AD: { name: "Andorra", alpha2: 'AD', alpha3: 'AND', numeric: '020', capital: "Andorra la Vella" },
  AE: { name: "United Arab Emirates", alpha2: 'AE', alpha3: 'ARE', numeric: '784', capital: "Abu Dhabi" },
  AF: { name: "Afghanistan", alpha2: 'AF', alpha3: 'AFG', numeric: '004', capital: "Kabul" },
  AG: { name: "Antigua and Barbuda", alpha2: 'AG', alpha3: 'ATG', numeric: '028', capital: "Saint John's" },
  AI: { name: "Anguilla", alpha2: 'AI', alpha3: 'AIA', numeric: '660', capital: "The Valley" },
  AL: { name: "Albania", alpha2: 'AL', alpha3: 'ALB', numeric: '008', capital: "Tirana" },
  AM: { name: "Armenia", alpha2: 'AM', alpha3: 'ARM', numeric: '051', capital: "Yerevan" },
  AO: { name: "Angola", alpha2: 'AO', alpha3: 'AGO', numeric: '024', capital: "Luanda" },
  AQ: {
    name: "Antarctica",
    alpha2: 'AQ',
    alpha3: 'ATA',
    numeric: '010',
    capital: "McMurdo Station",
  },
  AR: { name: "Argentina", alpha2: 'AR', alpha3: 'ARG', numeric: '032', capital: "Buenos Aires" },
  AS: { name: "American Samoa", alpha2: 'AS', alpha3: 'ASM', numeric: '016', capital: "Pago Pago" },
  AT: { name: "Austria", alpha2: 'AT', alpha3: 'AUT', numeric: '040', capital: "Vienna" },
  AU: { name: "Australia", alpha2: 'AU', alpha3: 'AUS', numeric: '036', capital: "Canberra" },
  AW: { name: "Aruba", alpha2: 'AW', alpha3: 'ABW', numeric: '533', capital: "Oranjestad" },
  AX: { name: "Aland Islands", alpha2: 'AX', alpha3: 'ALA', numeric: '248', capital: "Mariehamn" },
  AZ: { name: "Azerbaijan", alpha2: 'AZ', alpha3: 'AZE', numeric: '031', capital: "Baku" },
  BA: { name: "Bosnia and Herzegovina", alpha2: 'BA', alpha3: 'BIH', numeric: '070', capital: "Sarajevo" },
  BB: { name: "Barbados", alpha2: 'BB', alpha3: 'BRB', numeric: '052', capital: "Bridgetown" },
  BD: { name: "Bangladesh", alpha2: 'BD', alpha3: 'BGD', numeric: '050', capital: "Dhaka" },
  BE: { name: "Belgium", alpha2: 'BE', alpha3: 'BEL', numeric: '056', capital: "Brussels" },
  BF: { name: "Burkina Faso", alpha2: 'BF', alpha3: 'BFA', numeric: '854', capital: "Ouagadougou" },
  BG: { name: "Bulgaria", alpha2: 'BG', alpha3: 'BGR', numeric: '100', capital: "Sofia" },
  BH: { name: "Bahrain", alpha2: 'BH', alpha3: 'BHR', numeric: '048', capital: "Manama" },
  BI: { name: "Burundi", alpha2: 'BI', alpha3: 'BDI', numeric: '108', capital: "Gitega" },
  BJ: { name: "Benin", alpha2: 'BJ', alpha3: 'BEN', numeric: '204', capital: "Porto-Novo" },
  BL: { name: "Saint Barthelemy", alpha2: 'BL', alpha3: 'BLM', numeric: '652', capital: "Gustavia" },
  BM: { name: "Bermuda", alpha2: 'BM', alpha3: 'BMU', numeric: '060', capital: "Hamilton" },
  BN: { name: "Brunei", alpha2: 'BN', alpha3: 'BRN', numeric: '096', capital: "Bandar Seri Begawan" },
  BO: { name: "Bolivia", alpha2: 'BO', alpha3: 'BOL', numeric: '068', capital: "Sucre" },
  BQ: { name: "Caribbean Netherlands", alpha2: 'BQ', alpha3: 'BES', numeric: '535', capital: "Kralendijk" },
  BR: { name: "Brazil", alpha2: 'BR', alpha3: 'BRA', numeric: '076', capital: "Brasilia" },
  BS: { name: "Bahamas", alpha2: 'BS', alpha3: 'BHS', numeric: '044', capital: "Nassau" },
  BT: { name: "Bhutan", alpha2: 'BT', alpha3: 'BTN', numeric: '064', capital: "Thimphu" },
  BV: {
    name: "Bouvet Island",
    alpha2: 'BV',
    alpha3: 'BVT',
    numeric: '074',
    capital: "Bouvet Island",
  },
  BW: { name: "Botswana", alpha2: 'BW', alpha3: 'BWA', numeric: '072', capital: "Gaborone" },
  BY: { name: "Belarus", alpha2: 'BY', alpha3: 'BLR', numeric: '112', capital: "Minsk" },
  BZ: { name: "Belize", alpha2: 'BZ', alpha3: 'BLZ', numeric: '084', capital: "Belmopan" },
  CA: { name: "Canada", alpha2: 'CA', alpha3: 'CAN', numeric: '124', capital: "Ottawa" },
  CC: { name: "Cocos (Keeling) Islands", alpha2: 'CC', alpha3: 'CCK', numeric: '166', capital: "West Island" },
  CD: { name: "DR Congo", alpha2: 'CD', alpha3: 'COD', numeric: '180', capital: "Kinshasa" },
  CF: { name: "Central African Republic", alpha2: 'CF', alpha3: 'CAF', numeric: '140', capital: "Bangui" },
  CG: { name: "Republic of the Congo", alpha2: 'CG', alpha3: 'COG', numeric: '178', capital: "Brazzaville" },
  CH: { name: "Switzerland", alpha2: 'CH', alpha3: 'CHE', numeric: '756', capital: "Bern" },
  CI: { name: "Ivory Coast", alpha2: 'CI', alpha3: 'CIV', numeric: '384', capital: "Yamoussoukro" },
  CK: { name: "Cook Islands", alpha2: 'CK', alpha3: 'COK', numeric: '184', capital: "Avarua" },
  CL: { name: "Chile", alpha2: 'CL', alpha3: 'CHL', numeric: '152', capital: "Santiago" },
  CM: { name: "Cameroon", alpha2: 'CM', alpha3: 'CMR', numeric: '120', capital: "Yaounde" },
  CN: { name: "China", alpha2: 'CN', alpha3: 'CHN', numeric: '156', capital: "Beijing" },
  CO: { name: "Colombia", alpha2: 'CO', alpha3: 'COL', numeric: '170', capital: "Bogota" },
  CR: { name: "Costa Rica", alpha2: 'CR', alpha3: 'CRI', numeric: '188', capital: "San Jose" },
  CU: { name: "Cuba", alpha2: 'CU', alpha3: 'CUB', numeric: '192', capital: "Havana" },
  CV: { name: "Cape Verde", alpha2: 'CV', alpha3: 'CPV', numeric: '132', capital: "Praia" },
  CW: { name: "Curacao", alpha2: 'CW', alpha3: 'CUW', numeric: '531', capital: "Willemstad" },
  CX: { name: "Christmas Island", alpha2: 'CX', alpha3: 'CXR', numeric: '162', capital: "Flying Fish Cove" },
  CY: { name: "Cyprus", alpha2: 'CY', alpha3: 'CYP', numeric: '196', capital: "Nicosia" },
  CZ: { name: "Czechia", alpha2: 'CZ', alpha3: 'CZE', numeric: '203', capital: "Prague" },
  DE: { name: "Germany", alpha2: 'DE', alpha3: 'DEU', numeric: '276', capital: "Berlin" },
  DJ: { name: "Djibouti", alpha2: 'DJ', alpha3: 'DJI', numeric: '262', capital: "Djibouti" },
  DK: { name: "Denmark", alpha2: 'DK', alpha3: 'DNK', numeric: '208', capital: "Copenhagen" },
  DM: { name: "Dominica", alpha2: 'DM', alpha3: 'DMA', numeric: '212', capital: "Roseau" },
  DO: { name: "Dominican Republic", alpha2: 'DO', alpha3: 'DOM', numeric: '214', capital: "Santo Domingo" },
  DZ: { name: "Algeria", alpha2: 'DZ', alpha3: 'DZA', numeric: '012', capital: "Algiers" },
  EC: { name: "Ecuador", alpha2: 'EC', alpha3: 'ECU', numeric: '218', capital: "Quito" },
  EE: { name: "Estonia", alpha2: 'EE', alpha3: 'EST', numeric: '233', capital: "Tallinn" },
  EG: { name: "Egypt", alpha2: 'EG', alpha3: 'EGY', numeric: '818', capital: "Cairo" },
  EH: { name: "Western Sahara", alpha2: 'EH', alpha3: 'ESH', numeric: '732', capital: "El Aaiun" },
  ER: { name: "Eritrea", alpha2: 'ER', alpha3: 'ERI', numeric: '232', capital: "Asmara" },
  ES: { name: "Spain", alpha2: 'ES', alpha3: 'ESP', numeric: '724', capital: "Madrid" },
  ET: { name: "Ethiopia", alpha2: 'ET', alpha3: 'ETH', numeric: '231', capital: "Addis Ababa" },
  FI: { name: "Finland", alpha2: 'FI', alpha3: 'FIN', numeric: '246', capital: "Helsinki" },
  FJ: { name: "Fiji", alpha2: 'FJ', alpha3: 'FJI', numeric: '242', capital: "Suva" },
  FK: { name: "Falkland Islands", alpha2: 'FK', alpha3: 'FLK', numeric: '238', capital: "Stanley" },
  FM: { name: "Micronesia", alpha2: 'FM', alpha3: 'FSM', numeric: '583', capital: "Palikir" },
  FO: { name: "Faroe Islands", alpha2: 'FO', alpha3: 'FRO', numeric: '234', capital: "Torshavn" },
  FR: { name: "France", alpha2: 'FR', alpha3: 'FRA', numeric: '250', capital: "Paris" },
  GA: { name: "Gabon", alpha2: 'GA', alpha3: 'GAB', numeric: '266', capital: "Libreville" },
  GB: { name: "United Kingdom", alpha2: 'GB', alpha3: 'GBR', numeric: '826', capital: "London" },
  GD: { name: "Grenada", alpha2: 'GD', alpha3: 'GRD', numeric: '308', capital: "St. George's" },
  GE: { name: "Georgia", alpha2: 'GE', alpha3: 'GEO', numeric: '268', capital: "Tbilisi" },
  GF: { name: "French Guiana", alpha2: 'GF', alpha3: 'GUF', numeric: '254', capital: "Cayenne" },
  GG: { name: "Guernsey", alpha2: 'GG', alpha3: 'GGY', numeric: '831', capital: "St. Peter Port" },
  GH: { name: "Ghana", alpha2: 'GH', alpha3: 'GHA', numeric: '288', capital: "Accra" },
  GI: { name: "Gibraltar", alpha2: 'GI', alpha3: 'GIB', numeric: '292', capital: "Gibraltar" },
  GL: { name: "Greenland", alpha2: 'GL', alpha3: 'GRL', numeric: '304', capital: "Nuuk" },
  GM: { name: "Gambia", alpha2: 'GM', alpha3: 'GMB', numeric: '270', capital: "Banjul" },
  GN: { name: "Guinea", alpha2: 'GN', alpha3: 'GIN', numeric: '324', capital: "Conakry" },
  GP: { name: "Guadeloupe", alpha2: 'GP', alpha3: 'GLP', numeric: '312', capital: "Basse-Terre" },
  GQ: { name: "Equatorial Guinea", alpha2: 'GQ', alpha3: 'GNQ', numeric: '226', capital: "Malabo" },
  GR: { name: "Greece", alpha2: 'GR', alpha3: 'GRC', numeric: '300', capital: "Athens" },
  GS: { name: "South Georgia", alpha2: 'GS', alpha3: 'SGS', numeric: '239', capital: "King Edward Point" },
  GT: { name: "Guatemala", alpha2: 'GT', alpha3: 'GTM', numeric: '320', capital: "Guatemala City" },
  GU: { name: "Guam", alpha2: 'GU', alpha3: 'GUM', numeric: '316', capital: "Hagatna" },
  GW: { name: "Guinea-Bissau", alpha2: 'GW', alpha3: 'GNB', numeric: '624', capital: "Bissau" },
  GY: { name: "Guyana", alpha2: 'GY', alpha3: 'GUY', numeric: '328', capital: "Georgetown" },
  HK: { name: "Hong Kong", alpha2: 'HK', alpha3: 'HKG', numeric: '344', capital: "City of Victoria" },
  HM: {
    name: "Heard Island and McDonald Islands",
    alpha2: 'HM',
    alpha3: 'HMD',
    numeric: '334',
    capital: "Heard Island",
  },
  HN: { name: "Honduras", alpha2: 'HN', alpha3: 'HND', numeric: '340', capital: "Tegucigalpa" },
  HR: { name: "Croatia", alpha2: 'HR', alpha3: 'HRV', numeric: '191', capital: "Zagreb" },
  HT: { name: "Haiti", alpha2: 'HT', alpha3: 'HTI', numeric: '332', capital: "Port-au-Prince" },
  HU: { name: "Hungary", alpha2: 'HU', alpha3: 'HUN', numeric: '348', capital: "Budapest" },
  ID: { name: "Indonesia", alpha2: 'ID', alpha3: 'IDN', numeric: '360', capital: "Jakarta" },
  IE: { name: "Ireland", alpha2: 'IE', alpha3: 'IRL', numeric: '372', capital: "Dublin" },
  IL: { name: "Israel", alpha2: 'IL', alpha3: 'ISR', numeric: '376', capital: "Jerusalem" },
  IM: { name: "Isle of Man", alpha2: 'IM', alpha3: 'IMN', numeric: '833', capital: "Douglas" },
  IN: { name: "India", alpha2: 'IN', alpha3: 'IND', numeric: '356', capital: "New Delhi" },
  IO: { name: "British Indian Ocean Territory", alpha2: 'IO', alpha3: 'IOT', numeric: '086', capital: "Diego Garcia" },
  IQ: { name: "Iraq", alpha2: 'IQ', alpha3: 'IRQ', numeric: '368', capital: "Baghdad" },
  IR: { name: "Iran", alpha2: 'IR', alpha3: 'IRN', numeric: '364', capital: "Tehran" },
  IS: { name: "Iceland", alpha2: 'IS', alpha3: 'ISL', numeric: '352', capital: "Reykjavik" },
  IT: { name: "Italy", alpha2: 'IT', alpha3: 'ITA', numeric: '380', capital: "Rome" },
  JE: { name: "Jersey", alpha2: 'JE', alpha3: 'JEY', numeric: '832', capital: "Saint Helier" },
  JM: { name: "Jamaica", alpha2: 'JM', alpha3: 'JAM', numeric: '388', capital: "Kingston" },
  JO: { name: "Jordan", alpha2: 'JO', alpha3: 'JOR', numeric: '400', capital: "Amman" },
  JP: { name: "Japan", alpha2: 'JP', alpha3: 'JPN', numeric: '392', capital: "Tokyo" },
  KE: { name: "Kenya", alpha2: 'KE', alpha3: 'KEN', numeric: '404', capital: "Nairobi" },
  KG: { name: "Kyrgyzstan", alpha2: 'KG', alpha3: 'KGZ', numeric: '417', capital: "Bishkek" },
  KH: { name: "Cambodia", alpha2: 'KH', alpha3: 'KHM', numeric: '116', capital: "Phnom Penh" },
  KI: { name: "Kiribati", alpha2: 'KI', alpha3: 'KIR', numeric: '296', capital: "South Tarawa" },
  KM: { name: "Comoros", alpha2: 'KM', alpha3: 'COM', numeric: '174', capital: "Moroni" },
  KN: { name: "Saint Kitts and Nevis", alpha2: 'KN', alpha3: 'KNA', numeric: '659', capital: "Basseterre" },
  KP: { name: "North Korea", alpha2: 'KP', alpha3: 'PRK', numeric: '408', capital: "Pyongyang" },
  KR: { name: "South Korea", alpha2: 'KR', alpha3: 'KOR', numeric: '410', capital: "Seoul" },
  KW: { name: "Kuwait", alpha2: 'KW', alpha3: 'KWT', numeric: '414', capital: "Kuwait City" },
  KY: { name: "Cayman Islands", alpha2: 'KY', alpha3: 'CYM', numeric: '136', capital: "George Town" },
  KZ: { name: "Kazakhstan", alpha2: 'KZ', alpha3: 'KAZ', numeric: '398', capital: "Astana" },
  LA: { name: "Laos", alpha2: 'LA', alpha3: 'LAO', numeric: '418', capital: "Vientiane" },
  LB: { name: "Lebanon", alpha2: 'LB', alpha3: 'LBN', numeric: '422', capital: "Beirut" },
  LC: { name: "Saint Lucia", alpha2: 'LC', alpha3: 'LCA', numeric: '662', capital: "Castries" },
  LI: { name: "Liechtenstein", alpha2: 'LI', alpha3: 'LIE', numeric: '438', capital: "Vaduz" },
  LK: { name: "Sri Lanka", alpha2: 'LK', alpha3: 'LKA', numeric: '144', capital: "Sri Jayawardenepura Kotte" },
  LR: { name: "Liberia", alpha2: 'LR', alpha3: 'LBR', numeric: '430', capital: "Monrovia" },
  LS: { name: "Lesotho", alpha2: 'LS', alpha3: 'LSO', numeric: '426', capital: "Maseru" },
  LT: { name: "Lithuania", alpha2: 'LT', alpha3: 'LTU', numeric: '440', capital: "Vilnius" },
  LU: { name: "Luxembourg", alpha2: 'LU', alpha3: 'LUX', numeric: '442', capital: "Luxembourg" },
  LV: { name: "Latvia", alpha2: 'LV', alpha3: 'LVA', numeric: '428', capital: "Riga" },
  LY: { name: "Libya", alpha2: 'LY', alpha3: 'LBY', numeric: '434', capital: "Tripoli" },
  MA: { name: "Morocco", alpha2: 'MA', alpha3: 'MAR', numeric: '504', capital: "Rabat" },
  MC: { name: "Monaco", alpha2: 'MC', alpha3: 'MCO', numeric: '492', capital: "Monaco" },
  MD: { name: "Moldova", alpha2: 'MD', alpha3: 'MDA', numeric: '498', capital: "Chisinau" },
  ME: { name: "Montenegro", alpha2: 'ME', alpha3: 'MNE', numeric: '499', capital: "Podgorica" },
  MF: { name: "Saint Martin", alpha2: 'MF', alpha3: 'MAF', numeric: '663', capital: "Marigot" },
  MG: { name: "Madagascar", alpha2: 'MG', alpha3: 'MDG', numeric: '450', capital: "Antananarivo" },
  MH: { name: "Marshall Islands", alpha2: 'MH', alpha3: 'MHL', numeric: '584', capital: "Majuro" },
  MK: { name: "North Macedonia", alpha2: 'MK', alpha3: 'MKD', numeric: '807', capital: "Skopje" },
  ML: { name: "Mali", alpha2: 'ML', alpha3: 'MLI', numeric: '466', capital: "Bamako" },
  MM: { name: "Myanmar", alpha2: 'MM', alpha3: 'MMR', numeric: '104', capital: "Naypyidaw" },
  MN: { name: "Mongolia", alpha2: 'MN', alpha3: 'MNG', numeric: '496', capital: "Ulan Bator" },
  MO: {
    name: "Macau",
    alpha2: 'MO',
    alpha3: 'MAC',
    numeric: '446',
    capital: "Macau",
  },
  MP: { name: "Northern Mariana Islands", alpha2: 'MP', alpha3: 'MNP', numeric: '580', capital: "Saipan" },
  MQ: { name: "Martinique", alpha2: 'MQ', alpha3: 'MTQ', numeric: '474', capital: "Fort-de-France" },
  MR: { name: "Mauritania", alpha2: 'MR', alpha3: 'MRT', numeric: '478', capital: "Nouakchott" },
  MS: { name: "Montserrat", alpha2: 'MS', alpha3: 'MSR', numeric: '500', capital: "Plymouth" },
  MT: { name: "Malta", alpha2: 'MT', alpha3: 'MLT', numeric: '470', capital: "Valletta" },
  MU: { name: "Mauritius", alpha2: 'MU', alpha3: 'MUS', numeric: '480', capital: "Port Louis" },
  MV: { name: "Maldives", alpha2: 'MV', alpha3: 'MDV', numeric: '462', capital: "Male" },
  MW: { name: "Malawi", alpha2: 'MW', alpha3: 'MWI', numeric: '454', capital: "Lilongwe" },
  MX: { name: "Mexico", alpha2: 'MX', alpha3: 'MEX', numeric: '484', capital: "Mexico City" },
  MY: { name: "Malaysia", alpha2: 'MY', alpha3: 'MYS', numeric: '458', capital: "Kuala Lumpur" },
  MZ: { name: "Mozambique", alpha2: 'MZ', alpha3: 'MOZ', numeric: '508', capital: "Maputo" },
  NA: { name: "Namibia", alpha2: 'NA', alpha3: 'NAM', numeric: '516', capital: "Windhoek" },
  NC: { name: "New Caledonia", alpha2: 'NC', alpha3: 'NCL', numeric: '540', capital: "Noumea" },
  NE: { name: "Niger", alpha2: 'NE', alpha3: 'NER', numeric: '562', capital: "Niamey" },
  NF: { name: "Norfolk Island", alpha2: 'NF', alpha3: 'NFK', numeric: '574', capital: "Kingston" },
  NG: { name: "Nigeria", alpha2: 'NG', alpha3: 'NGA', numeric: '566', capital: "Abuja" },
  NI: { name: "Nicaragua", alpha2: 'NI', alpha3: 'NIC', numeric: '558', capital: "Managua" },
  NL: { name: "Netherlands", alpha2: 'NL', alpha3: 'NLD', numeric: '528', capital: "Amsterdam" },
  NO: { name: "Norway", alpha2: 'NO', alpha3: 'NOR', numeric: '578', capital: "Oslo" },
  NP: { name: "Nepal", alpha2: 'NP', alpha3: 'NPL', numeric: '524', capital: "Kathmandu" },
  NR: { name: "Nauru", alpha2: 'NR', alpha3: 'NRU', numeric: '520', capital: "Yaren" },
  NU: { name: "Niue", alpha2: 'NU', alpha3: 'NIU', numeric: '570', capital: "Alofi" },
  NZ: { name: "New Zealand", alpha2: 'NZ', alpha3: 'NZL', numeric: '554', capital: "Wellington" },
  OM: { name: "Oman", alpha2: 'OM', alpha3: 'OMN', numeric: '512', capital: "Muscat" },
  PA: { name: "Panama", alpha2: 'PA', alpha3: 'PAN', numeric: '591', capital: "Panama City" },
  PE: { name: "Peru", alpha2: 'PE', alpha3: 'PER', numeric: '604', capital: "Lima" },
  PF: { name: "French Polynesia", alpha2: 'PF', alpha3: 'PYF', numeric: '258', capital: "Papeete" },
  PG: { name: "Papua New Guinea", alpha2: 'PG', alpha3: 'PNG', numeric: '598', capital: "Port Moresby" },
  PH: { name: "Philippines", alpha2: 'PH', alpha3: 'PHL', numeric: '608', capital: "Manila" },
  PK: { name: "Pakistan", alpha2: 'PK', alpha3: 'PAK', numeric: '586', capital: "Islamabad" },
  PL: { name: "Poland", alpha2: 'PL', alpha3: 'POL', numeric: '616', capital: "Warsaw" },
  PM: { name: "Saint Pierre and Miquelon", alpha2: 'PM', alpha3: 'SPM', numeric: '666', capital: "Saint-Pierre" },
  PN: { name: "Pitcairn Islands", alpha2: 'PN', alpha3: 'PCN', numeric: '612', capital: "Adamstown" },
  PR: { name: "Puerto Rico", alpha2: 'PR', alpha3: 'PRI', numeric: '630', capital: "San Juan" },
  PS: { name: "Palestine", alpha2: 'PS', alpha3: 'PSE', numeric: '275', capital: "Ramallah" },
  PT: { name: "Portugal", alpha2: 'PT', alpha3: 'PRT', numeric: '620', capital: "Lisbon" },
  PW: { name: "Palau", alpha2: 'PW', alpha3: 'PLW', numeric: '585', capital: "Ngerulmud" },
  PY: { name: "Paraguay", alpha2: 'PY', alpha3: 'PRY', numeric: '600', capital: "Asuncion" },
  QA: { name: "Qatar", alpha2: 'QA', alpha3: 'QAT', numeric: '634', capital: "Doha" },
  RE: { name: "Reunion", alpha2: 'RE', alpha3: 'REU', numeric: '638', capital: "Saint-Denis" },
  RO: { name: "Romania", alpha2: 'RO', alpha3: 'ROU', numeric: '642', capital: "Bucharest" },
  RS: { name: "Serbia", alpha2: 'RS', alpha3: 'SRB', numeric: '688', capital: "Belgrade" },
  RU: { name: "Russia", alpha2: 'RU', alpha3: 'RUS', numeric: '643', capital: "Moscow" },
  RW: { name: "Rwanda", alpha2: 'RW', alpha3: 'RWA', numeric: '646', capital: "Kigali" },
  SA: { name: "Saudi Arabia", alpha2: 'SA', alpha3: 'SAU', numeric: '682', capital: "Riyadh" },
  SB: { name: "Solomon Islands", alpha2: 'SB', alpha3: 'SLB', numeric: '090', capital: "Honiara" },
  SC: { name: "Seychelles", alpha2: 'SC', alpha3: 'SYC', numeric: '690', capital: "Victoria" },
  SD: { name: "Sudan", alpha2: 'SD', alpha3: 'SDN', numeric: '729', capital: "Khartoum" },
  SE: { name: "Sweden", alpha2: 'SE', alpha3: 'SWE', numeric: '752', capital: "Stockholm" },
  SG: { name: "Singapore", alpha2: 'SG', alpha3: 'SGP', numeric: '702', capital: "Singapore" },
  SH: { name: "Saint Helena, Ascension and Tristan da Cunha", alpha2: 'SH', alpha3: 'SHN', numeric: '654', capital: "Jamestown" },
  SI: { name: "Slovenia", alpha2: 'SI', alpha3: 'SVN', numeric: '705', capital: "Ljubljana" },
  SJ: { name: "Svalbard and Jan Mayen", alpha2: 'SJ', alpha3: 'SJM', numeric: '744', capital: "Longyearbyen" },
  SK: { name: "Slovakia", alpha2: 'SK', alpha3: 'SVK', numeric: '703', capital: "Bratislava" },
  SL: { name: "Sierra Leone", alpha2: 'SL', alpha3: 'SLE', numeric: '694', capital: "Freetown" },
  SM: { name: "San Marino", alpha2: 'SM', alpha3: 'SMR', numeric: '674', capital: "City of San Marino" },
  SN: { name: "Senegal", alpha2: 'SN', alpha3: 'SEN', numeric: '686', capital: "Dakar" },
  SO: { name: "Somalia", alpha2: 'SO', alpha3: 'SOM', numeric: '706', capital: "Mogadishu" },
  SR: { name: "Suriname", alpha2: 'SR', alpha3: 'SUR', numeric: '740', capital: "Paramaribo" },
  SS: { name: "South Sudan", alpha2: 'SS', alpha3: 'SSD', numeric: '728', capital: "Juba" },
  ST: { name: "Sao Tome and Principe", alpha2: 'ST', alpha3: 'STP', numeric: '678', capital: "Sao Tome" },
  SV: { name: "El Salvador", alpha2: 'SV', alpha3: 'SLV', numeric: '222', capital: "San Salvador" },
  SX: { name: "Sint Maarten", alpha2: 'SX', alpha3: 'SXM', numeric: '534', capital: "Philipsburg" },
  SY: { name: "Syria", alpha2: 'SY', alpha3: 'SYR', numeric: '760', capital: "Damascus" },
  SZ: { name: "Eswatini", alpha2: 'SZ', alpha3: 'SWZ', numeric: '748', capital: "Mbabane" },
  TC: { name: "Turks and Caicos Islands", alpha2: 'TC', alpha3: 'TCA', numeric: '796', capital: "Cockburn Town" },
  TD: { name: "Chad", alpha2: 'TD', alpha3: 'TCD', numeric: '148', capital: "N'Djamena" },
  TF: { name: "French Southern and Antarctic Lands", alpha2: 'TF', alpha3: 'ATF', numeric: '260', capital: "Port-aux-Francais" },
  TG: { name: "Togo", alpha2: 'TG', alpha3: 'TGO', numeric: '768', capital: "Lome" },
  TH: { name: "Thailand", alpha2: 'TH', alpha3: 'THA', numeric: '764', capital: "Bangkok" },
  TJ: { name: "Tajikistan", alpha2: 'TJ', alpha3: 'TJK', numeric: '762', capital: "Dushanbe" },
  TK: { name: "Tokelau", alpha2: 'TK', alpha3: 'TKL', numeric: '772', capital: "Fakaofo" },
  TL: { name: "Timor-Leste", alpha2: 'TL', alpha3: 'TLS', numeric: '626', capital: "Dili" },
  TM: { name: "Turkmenistan", alpha2: 'TM', alpha3: 'TKM', numeric: '795', capital: "Ashgabat" },
  TN: { name: "Tunisia", alpha2: 'TN', alpha3: 'TUN', numeric: '788', capital: "Tunis" },
  TO: { name: "Tonga", alpha2: 'TO', alpha3: 'TON', numeric: '776', capital: "Nuku'alofa" },
  TR: { name: "Turkey", alpha2: 'TR', alpha3: 'TUR', numeric: '792', capital: "Ankara" },
  TT: { name: "Trinidad and Tobago", alpha2: 'TT', alpha3: 'TTO', numeric: '780', capital: "Port of Spain" },
  TV: { name: "Tuvalu", alpha2: 'TV', alpha3: 'TUV', numeric: '798', capital: "Funafuti" },
  TW: { name: "Taiwan", alpha2: 'TW', alpha3: 'TWN', numeric: '158', capital: "Taipei" },
  TZ: { name: "Tanzania", alpha2: 'TZ', alpha3: 'TZA', numeric: '834', capital: "Dodoma" },
  UA: { name: "Ukraine", alpha2: 'UA', alpha3: 'UKR', numeric: '804', capital: "Kyiv" },
  UG: { name: "Uganda", alpha2: 'UG', alpha3: 'UGA', numeric: '800', capital: "Kampala" },
  UM: { name: "United States Minor Outlying Islands", alpha2: 'UM', alpha3: 'UMI', numeric: '581', capital: "Washington DC" },
  US: { name: "United States", alpha2: 'US', alpha3: 'USA', numeric: '840', capital: "Washington, D.C." },
  UY: { name: "Uruguay", alpha2: 'UY', alpha3: 'URY', numeric: '858', capital: "Montevideo" },
  UZ: { name: "Uzbekistan", alpha2: 'UZ', alpha3: 'UZB', numeric: '860', capital: "Tashkent" },
  VA: { name: "Vatican City", alpha2: 'VA', alpha3: 'VAT', numeric: '336', capital: "Vatican City" },
  VC: { name: "Saint Vincent and the Grenadines", alpha2: 'VC', alpha3: 'VCT', numeric: '670', capital: "Kingstown" },
  VE: { name: "Venezuela", alpha2: 'VE', alpha3: 'VEN', numeric: '862', capital: "Caracas" },
  VG: { name: "British Virgin Islands", alpha2: 'VG', alpha3: 'VGB', numeric: '092', capital: "Road Town" },
  VI: { name: "United States Virgin Islands", alpha2: 'VI', alpha3: 'VIR', numeric: '850', capital: "Charlotte Amalie" },
  VN: { name: "Vietnam", alpha2: 'VN', alpha3: 'VNM', numeric: '704', capital: "Hanoi" },
  VU: { name: "Vanuatu", alpha2: 'VU', alpha3: 'VUT', numeric: '548', capital: "Port Vila" },
  WF: { name: "Wallis and Futuna", alpha2: 'WF', alpha3: 'WLF', numeric: '876', capital: "Mata-Utu" },
  WS: { name: "Samoa", alpha2: 'WS', alpha3: 'WSM', numeric: '882', capital: "Apia" },
  XK: { name: "Kosovo", alpha2: 'XK', alpha3: 'UNK', numeric: null, capital: "Pristina" },
  YE: { name: "Yemen", alpha2: 'YE', alpha3: 'YEM', numeric: '887', capital: "Sana'a" },
  YT: { name: "Mayotte", alpha2: 'YT', alpha3: 'MYT', numeric: '175', capital: "Mamoudzou" },
  ZA: { name: "South Africa", alpha2: 'ZA', alpha3: 'ZAF', numeric: '710', capital: "Pretoria" },
  ZM: { name: "Zambia", alpha2: 'ZM', alpha3: 'ZMB', numeric: '894', capital: "Lusaka" },
  ZW: { name: "Zimbabwe", alpha2: 'ZW', alpha3: 'ZWE', numeric: '716', capital: "Harare" },
};

export const ALPHA3_TO_ALPHA2 = {
  ABW: 'AW',
  AFG: 'AF',
  AGO: 'AO',
  AIA: 'AI',
  ALA: 'AX',
  ALB: 'AL',
  AND: 'AD',
  ARE: 'AE',
  ARG: 'AR',
  ARM: 'AM',
  ASM: 'AS',
  ATA: 'AQ',
  ATF: 'TF',
  ATG: 'AG',
  AUS: 'AU',
  AUT: 'AT',
  AZE: 'AZ',
  BDI: 'BI',
  BEL: 'BE',
  BEN: 'BJ',
  BES: 'BQ',
  BFA: 'BF',
  BGD: 'BD',
  BGR: 'BG',
  BHR: 'BH',
  BHS: 'BS',
  BIH: 'BA',
  BLM: 'BL',
  BLR: 'BY',
  BLZ: 'BZ',
  BMU: 'BM',
  BOL: 'BO',
  BRA: 'BR',
  BRB: 'BB',
  BRN: 'BN',
  BTN: 'BT',
  BVT: 'BV',
  BWA: 'BW',
  CAF: 'CF',
  CAN: 'CA',
  CCK: 'CC',
  CHE: 'CH',
  CHL: 'CL',
  CHN: 'CN',
  CIV: 'CI',
  CMR: 'CM',
  COD: 'CD',
  COG: 'CG',
  COK: 'CK',
  COL: 'CO',
  COM: 'KM',
  CPV: 'CV',
  CRI: 'CR',
  CUB: 'CU',
  CUW: 'CW',
  CXR: 'CX',
  CYM: 'KY',
  CYP: 'CY',
  CZE: 'CZ',
  DEU: 'DE',
  DJI: 'DJ',
  DMA: 'DM',
  DNK: 'DK',
  DOM: 'DO',
  DZA: 'DZ',
  ECU: 'EC',
  EGY: 'EG',
  ERI: 'ER',
  ESH: 'EH',
  ESP: 'ES',
  EST: 'EE',
  ETH: 'ET',
  FIN: 'FI',
  FJI: 'FJ',
  FLK: 'FK',
  FRA: 'FR',
  FRO: 'FO',
  FSM: 'FM',
  GAB: 'GA',
  GBR: 'GB',
  GEO: 'GE',
  GGY: 'GG',
  GHA: 'GH',
  GIB: 'GI',
  GIN: 'GN',
  GLP: 'GP',
  GMB: 'GM',
  GNB: 'GW',
  GNQ: 'GQ',
  GRC: 'GR',
  GRD: 'GD',
  GRL: 'GL',
  GTM: 'GT',
  GUF: 'GF',
  GUM: 'GU',
  GUY: 'GY',
  HKG: 'HK',
  HMD: 'HM',
  HND: 'HN',
  HRV: 'HR',
  HTI: 'HT',
  HUN: 'HU',
  IDN: 'ID',
  IMN: 'IM',
  IND: 'IN',
  IOT: 'IO',
  IRL: 'IE',
  IRN: 'IR',
  IRQ: 'IQ',
  ISL: 'IS',
  ISR: 'IL',
  ITA: 'IT',
  JAM: 'JM',
  JEY: 'JE',
  JOR: 'JO',
  JPN: 'JP',
  KAZ: 'KZ',
  KEN: 'KE',
  KGZ: 'KG',
  KHM: 'KH',
  KIR: 'KI',
  KNA: 'KN',
  KOR: 'KR',
  KWT: 'KW',
  LAO: 'LA',
  LBN: 'LB',
  LBR: 'LR',
  LBY: 'LY',
  LCA: 'LC',
  LIE: 'LI',
  LKA: 'LK',
  LSO: 'LS',
  LTU: 'LT',
  LUX: 'LU',
  LVA: 'LV',
  MAC: 'MO',
  MAF: 'MF',
  MAR: 'MA',
  MCO: 'MC',
  MDA: 'MD',
  MDG: 'MG',
  MDV: 'MV',
  MEX: 'MX',
  MHL: 'MH',
  MKD: 'MK',
  MLI: 'ML',
  MLT: 'MT',
  MMR: 'MM',
  MNE: 'ME',
  MNG: 'MN',
  MNP: 'MP',
  MOZ: 'MZ',
  MRT: 'MR',
  MSR: 'MS',
  MTQ: 'MQ',
  MUS: 'MU',
  MWI: 'MW',
  MYS: 'MY',
  MYT: 'YT',
  NAM: 'NA',
  NCL: 'NC',
  NER: 'NE',
  NFK: 'NF',
  NGA: 'NG',
  NIC: 'NI',
  NIU: 'NU',
  NLD: 'NL',
  NOR: 'NO',
  NPL: 'NP',
  NRU: 'NR',
  NZL: 'NZ',
  OMN: 'OM',
  PAK: 'PK',
  PAN: 'PA',
  PCN: 'PN',
  PER: 'PE',
  PHL: 'PH',
  PLW: 'PW',
  PNG: 'PG',
  POL: 'PL',
  PRI: 'PR',
  PRK: 'KP',
  PRT: 'PT',
  PRY: 'PY',
  PSE: 'PS',
  PYF: 'PF',
  QAT: 'QA',
  REU: 'RE',
  ROU: 'RO',
  RUS: 'RU',
  RWA: 'RW',
  SAU: 'SA',
  SDN: 'SD',
  SEN: 'SN',
  SGP: 'SG',
  SGS: 'GS',
  SHN: 'SH',
  SJM: 'SJ',
  SLB: 'SB',
  SLE: 'SL',
  SLV: 'SV',
  SMR: 'SM',
  SOM: 'SO',
  SPM: 'PM',
  SRB: 'RS',
  SSD: 'SS',
  STP: 'ST',
  SUR: 'SR',
  SVK: 'SK',
  SVN: 'SI',
  SWE: 'SE',
  SWZ: 'SZ',
  SXM: 'SX',
  SYC: 'SC',
  SYR: 'SY',
  TCA: 'TC',
  TCD: 'TD',
  TGO: 'TG',
  THA: 'TH',
  TJK: 'TJ',
  TKL: 'TK',
  TKM: 'TM',
  TLS: 'TL',
  TON: 'TO',
  TTO: 'TT',
  TUN: 'TN',
  TUR: 'TR',
  TUV: 'TV',
  TWN: 'TW',
  TZA: 'TZ',
  UGA: 'UG',
  UKR: 'UA',
  UMI: 'UM',
  UNK: 'XK',
  URY: 'UY',
  USA: 'US',
  UZB: 'UZ',
  VAT: 'VA',
  VCT: 'VC',
  VEN: 'VE',
  VGB: 'VG',
  VIR: 'VI',
  VNM: 'VN',
  VUT: 'VU',
  WLF: 'WF',
  WSM: 'WS',
  YEM: 'YE',
  ZAF: 'ZA',
  ZMB: 'ZM',
  ZWE: 'ZW',
};

export const NORMALIZE_CAPITAL_ENTRY = (entry) => {
  if (!entry) return entry;
  return {
    ...entry,
    name: entry.name || ALPHA2_TO_METADATA[entry.alpha2]?.name || null,
    capital: entry.capital || ALPHA2_TO_METADATA[entry.alpha2]?.capital || null,
  };
};

export default { ALPHA2_TO_METADATA, ALPHA3_TO_ALPHA2 };
